import mainLogo from "@/assets/aion-logos/logo-01-main.png";
import voiceLogo from "@/assets/aion-logos/logo-06-voice.png";
import compactLogo from "@/assets/aion-logos/logo-10-icon.png";
import roboticsLogo from "@/assets/aion-logos/logo-13-robotics.png";
import softwareLogo from "@/assets/aion-logos/logo-18-software.png";

const LOGO_VARIANTS = {
  main: {
    alt: "AION Hauptlogo",
    src: mainLogo,
  },
  voice: {
    alt: "AION Sprachassistent Logo",
    src: voiceLogo,
  },
  compact: {
    alt: "AION kompaktes App-Icon",
    src: compactLogo,
  },
  robotics: {
    alt: "AION Robotics Logo",
    src: roboticsLogo,
  },
  software: {
    alt: "AION Software Logo",
    src: softwareLogo,
  },
};

export const AionLogoArtwork = ({
  variant = "main",
  alt,
  className = "",
  imageClassName = "",
  dataTestId,
}) => {
  const selected = LOGO_VARIANTS[variant] || LOGO_VARIANTS.main;

  return (
    <div className={`aion-logo-frame aion-logo-frame-${variant} ${className}`.trim()}>
      <img
        src={selected.src}
        alt={alt || selected.alt}
        className={`aion-logo-image aion-logo-image-${variant} ${imageClassName}`.trim()}
        data-testid={dataTestId}
      />
    </div>
  );
};